export const FIC_FIDC_CHART_COLORS = [
  '#FF8211',
  '#3B82F6',
  '#27AE60',
  '#E2B93B',
  '#8B5CF6',
  '#EB5757',
  '#14B8A6',
  '#F97316',
  '#6366F1',
  '#6D6E71',
] as const;
